@let VDRJob = vdrJob$ | async;
<div class="modal-container">
  <p-select
    [options]="(pslDatasource$ | async) || []"
    [(ngModel)]="currentPSL"
    optionLabel="name"
    appendTo="body"
    styleClass="w-full"
    emptyMessage="No Result Found"
    placeholder="Select PSL"
    [disabled]="!!VDRJob"
  ></p-select>
  @if (previousPSLId && currentPSL && previousPSLId !== currentPSL.id) {
    <p class="text-yellow-500">Note: Changing the PSL will reset all selected data.</p>
  }

  <div class="btn-psl-action">
    <p-button label="Select" styleClass="btn-contrast-workflow" [disabled]="!currentPSL.id" (click)="selectItem()" />
    @if (this.previousPSLId && !VDRJob) {
      <p-button label="Cancel" styleClass="btn-outlined-dark btn-workflow !px-6 !py-[7px] h-[38px]" (click)="close()" />
    }
  </div>
</div>
